<div class="">
  <div class="">
    <div class="card">
      <div class="card-body">
        <div class="card-title">
          {{ isEditing ? "Update" : "Create" }} Issue
        </div>
        <form
          #formDirective="ngForm"
          [formGroup]="issueForm"
          autocomplete="off"
        >
          <div class="form-group">
            <label class="form-label">Reporting Date</label>
            <input
              formControlName="reportingDate"
              type="text"
              placeholder="Reporting Date"
              class="form-control"
              placement="bottom"
              bsDatepicker
            />
          </div>
          <div class="form-group">
            <label class="form-label">Description</label>
            <input
              type="text"
              class="form-control"
              placeholder="Description"
              formControlName="description"
            />
          </div>
          <div class="form-group">
            <label class="form-label">Close by</label>
            <input
              type="text"
              placeholder="Close By"
              class="form-control"
              placement="bottom"
              bsDatepicker
              formControlName="plannedCloseDate"
            />
          </div>
          <div class="form-group">
            <label class="form-label">Action Party</label>
            <select
              class="form-control"
              placeholder="Action Party"
              formControlName="actionParty"
            >
              <option
                *ngFor="let actionPartyOption of actionPartyOptions"
                [ngValue]="actionPartyOption"
              >
                {{ actionPartyOption }}
              </option>
            </select>
          </div>
          <div class="input-group mb-3" btnRadioGroup>
            <div class="form-check mr-2">
              <input
                class="form-check-input"
                type="radio"
                formControlName="status"
                value="Open"
                name="status"
                id="open"
              />
              <label for="open" class="form-check-label">Open</label>
            </div>
            <div class="form-check mr-2">
              <input
                class="form-check-input"
                type="radio"
                formControlName="status"
                value="Closed"
                name="status"
                id="closed"
              />
              <label for="closed" class="form-check-label">Closed</label>
            </div>
          </div>
          <div class="form-footer">
            <button
              class="btn btn-primary"
              type="submit"
              (click)="reportIssue()"
              [disabled]="!issueForm?.valid"
            >
              {{ isEditing ? "Update" : "Add" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
